<!-- eslint-disable max-len -->
<template>
  <v-container class="appDescriptionContainer">
    <v-layout>
      <v-flex>
        <div class="description text-xs-center">
          {{ productDescription }}
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import urlUtils from 'utils/url';

export default {
  name: 'TheDescription',
  props: {
    eventName: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    dateOfPurchase: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'recharge',
    },
    requirePayment: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    billingDescription: '',
    productDescription: '',
    productFromUrl: urlUtils.getProductFromDomain(),
    clientDisplayName: '',
  }),
  methods: {
    setProductDescription() {
      if (
        this.productFromUrl === 'enhancedrefundprogram'
        || this.productFromUrl === 'raas'
      ) {
        this.productDescription = `Yes! You bought the tickets and are counting down the days!
        But unforeseen circumstances can occur, which prevent you from attending your event as planned.
        By enrolling in the ${this.clientDisplayName}'s enhanced refund program, your purchase can be
        refunded if you are unable to attend due to the refundable reasons.`;
      } else if (this.productFromUrl === 'regshield') {
        this.productDescription = `Yes! You registered and are counting down the days!
        But unforeseen circumstances can occur, preventing you from participating in your event as planned.
        We recommend purchasing RegShield protection to cover the cost of your registration, should the unexpected happen.`;
      } else {
        this.productDescription = `Yes! You bought the tickets and are counting down the days!
    But unforeseen circumstances can occur, which prevent you from attending your event as planned.
    We recommend purchasing FanShield ticket protection to cover the cost of your ticket, should the unexpected happen.`;
      }
    },
    setClientDisplayName() {
      this.clientDisplayName = this.$parent.widgetData.client_display_name;
    },
  },
  mounted() {
    this.setClientDisplayName();
    this.setProductDescription();
    if (!this.requirePayment) {
      this.billingDescription = 'Below are the items which you tried to purchase protection for. In order to complete your purchase please update your billing address information.';
    } else {
      this.billingDescription = 'Below are the items which you tried to purchase protection for. In order to complete your purchase please update your billing address exactly as it appears on your credit card statement.';
    }
  },
};
</script>

<style scoped>
.appDescriptionContainer {
  padding-top: 0px;
}

.description {
  font-family: Gotham;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appDescriptionContainer {
    padding-top: 0px;
  }

  .description {
    margin-bottom: 15px;
  }
}

/* Mobile Break Point Larger */
@media screen and (min-width: 376px) and (max-width: 767px) {
  .description {
    margin: auto !important;
  }
}
</style>
